// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul li[data-v-21ef845c]{margin-left:40px;position:relative}ul li[data-v-21ef845c]:before{background-color:#7293b1;border-radius:999px;content:\"\";height:10px;left:-18px;position:absolute;top:6px;width:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
